"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const cachedRequest_1 = __importDefault(require("configs/cachedRequest"));
const featureToggle_1 = require("modules/featureToggle");
require("./FeatureToggleApi");
const FeatureToggleConstants_1 = require("./FeatureToggleConstants");
const request_1 = __importDefault(require("@hotmart/request"));
class FeatureToggleService {
    constructor() {
        this.isEnabled = (featureToggleName) => {
            return featureToggle_1.FeatureToggleStore.featureToggles.get(featureToggleName) || false;
        };
        this.getFeatureToggleStatus = async (featureToggleName, unleashId) => {
            const isFeatureToggleEnabled = await (0, cachedRequest_1.default)(() => (0, request_1.default)(FeatureToggleConstants_1.FeatureToggleEndpointKeys.GetToggleByUnleashId, {
                toggleName: featureToggleName,
                unleashId,
                attach_token: false
            }), [featureToggleName, unleashId]);
            return isFeatureToggleEnabled;
        };
        this.addRemoteFeature = async (featureToggleName, unleashId) => {
            const isRemoteFeatureToggleEnabled = await this.getFeatureToggleStatus(featureToggleName, unleashId);
            this.addFeature(featureToggleName, isRemoteFeatureToggleEnabled);
        };
        this.addFeature = (featureToggleName, status) => {
            featureToggle_1.FeatureToggleStore.add(featureToggleName, status);
        };
    }
}
exports.default = new FeatureToggleService();
